module.exports = __webpack_public_path__ + "img/close-btn.8026fdf7.svg";